<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="mb-3">
    <v-menu :close-on-content-click="false" min-width="0">
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex flex-row align-center">
          <div class="color-display mr-3" :style="{ backgroundColor: color }" v-on="on" v-bind="attrs"></div>
          <div :class="{ 'text-disabled': disabled }">{{ $t(title) }}</div>
        </div>
      </template>
      <v-card>
        <v-color-picker
          :value="color"
          class="color-picker"
          mode="hexa"
          hide-mode-switch
          :disabled="disabled"
          @update:color="updateColor"
        ></v-color-picker>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'EcsColorPicker',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    colorKey: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateColor: debounce(function({ hex }) {
      this.$emit('colorChange', hex, this.colorKey);
    }, 200)
  }
};
</script>

<style scoped>
.color-display {
  width: 64px;
  height: 64px;
  border-width: 2px;
  border-style: solid;
  border-color: white !important;
  border-radius: 50%;
}
.color-picker {
  margin: auto;
}
.text-disabled {
  color: gray;
}
</style>
